// src/services/configService.js
import { adminApiClient } from "./apiClient";

// const PUBLIC_ID = process.env.REACT_APP_PUBLIC_ID;

export const getConfiguration = async (publicId) => {
  try {
    //console.log("Fetching config for Public ID:", publicId);

    const res = await adminApiClient.get(
      `/Display_Config/GetDisplay_ConfigForPublicId`,
      { params: { public_Id: publicId } }
    );
    //console.log("Fetched config:", res.data);
    return res.data;
  } catch (err) {
    console.error("Error fetching display configuration:", err.response?.data || err.message);
    throw err;
  }
};
